export default class AssessmentsScreens {

  constructor() {}

  render() {

    // Submit form on click (default Rails submit button doesn't work with fa icons)
    $('#update_assessment_form_submit').click(function() {
      $('#assessment_screen_joins_form').submit();
    });

    // Define templates for check and minus
    const checkMark = function() {
      let check = "<svg style=\"top: 7px; left: 17px;\" width=\'20\' height=\'20\' class=\'position-absolute checkbox-svg clickable\' viewBox=\'0 0 20 20\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'>";
      check += "<g id=\'Tick Small\'><path id=\'Vector\' d=\'M5.33334 10.6251L8.08334 13.3333L14.6667 6.66667\' ";
      check += "stroke=\'white\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'></path></g></svg>";
      return check;
    }
    const checkMinus = function() {
      let minus = "<svg width=\'12\' height=\'12\' class=\'checkbox-minus clickable\' viewBox=\'0 0 16 16\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'>";
      minus += "<path stroke=\'#0B090F\' stroke-linecap=\'round\' stroke-linejoin=\'round\' d=\'M4.267 8h7.466\'></path>";
      return minus;
    }

    // Checkbox check on check
    $('input.checkbox').change(function() {
      console.log('Checkbox changed');
    })


    // Check for screen set active
    const checkActiveScreenSet = function(el) {
      let screen_ids = JSON.parse(el.attr('data-screen-ids'));
      let active = 0;
      $.each(screen_ids, function(index, sid) {
        let icon = $('.impact-assessment-icon[data-screen-id=\'' + sid + '\']');
        if ( (icon.hasClass('active')) && (active === index)) {
          el.addClass('active');
          active += 1;
        } else {
          el.removeClass('active');
        }
      });
    }
    $('.screen-set').each(function() { checkActiveScreenSet($(this)); });

    // Action when clicking on a card
    // Check the box when click a row or a checkbox in a row
    $('.impact-assessment-icon').on('click', function() {
      let checkbox = $(this).find('input[type=\'checkbox\']');
      let hiddenDestroy = $(this).find('input.hidden-destroy');

      // Check/uncheck the box and update val, depending on current state
      // Also update active class of card
      if (checkbox[0].checked === false) {
        checkbox.prop('checked', true);
        checkbox.val(checkbox.data("impact-screen-id"));
        hiddenDestroy.val('false');
        $(this).addClass('active');        
        $(this).append(checkMark());

      } else if (checkbox[0].checked === true) {
        checkbox.prop('checked', false);
        checkbox.val("");
        hiddenDestroy.val('true');
        $(this).removeClass('active');
        $(this).find('.checkbox-svg').remove();

      }

      // Check/uncheck screen sets
      let screen_set_ids = JSON.parse($(this).attr('data-screen-set-ids'));
      $.each(screen_set_ids, function(index, sid) {
        let setEl = $('.screen-set[data-screen-set-id=\'' + sid + '\']');
        checkActiveScreenSet(setEl);
      })

      // Blur focus; required in touch to update active class
      $(this).blur();

    });

    // Select/deselect all related screens on select of set
    $('.screen-set').click(function() {
      let screen_ids = JSON.parse($(this).attr('data-screen-ids'));

      if ($(this).hasClass('active')) {
        $.each(screen_ids, function(index, sid) {
          let icon = $('.impact-assessment-icon[data-screen-id=\'' + sid + '\']');
          let checkbox = icon.find('input[type=\'checkbox\']');
          let hiddenDestroy = icon.find('input.hidden-destroy');
          checkbox.prop('checked', false);
          checkbox.val("");
          hiddenDestroy.val('true');
          icon.removeClass('active');
          icon.find('.checkbox-svg').remove();
        });
        $(this).removeClass('active');

        if ($(this).hasClass('all-screens')) {
          $('.screen-set').removeClass('active');
        }

      } else {
        $.each(screen_ids, function(index, sid) {
          let icon = $('.impact-assessment-icon[data-screen-id=\'' + sid + '\']');
          let checkbox = icon.find('input[type=\'checkbox\']');
          let hiddenDestroy = icon.find('input.hidden-destroy');
          checkbox.prop('checked', true);
          checkbox.val(checkbox.data("impact-screen-id"));
          hiddenDestroy.val('false');
          icon.addClass('active');
          icon.append(checkMark());
        });
        $(this).addClass('active');

        if ($(this).hasClass('all-screens')) {
          $('.screen-set').addClass('active');
        }

      }

      // Blur focus; required in touch to update active class
      $(this).blur();

    });

  }

}